(function () {
    'use strict';

    angular
        .module('app.paymentTemplates')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'opsIncludeVersion'];
    /* @ngInject */
    function appRun(routerHelper, opsIncludeVersion) {
        routerHelper.configureStates(getStates(opsIncludeVersion));
    }

    function getStates(opsIncludeVersion) {
        return [
              {
                  state: 'paymenttemplates',
                  config: {
                      abstract: true,
                      url: '/paymenttemplates',
                      template: '<ui-view/>',
                      settings: {
                          authMode: 1
                      }
                  }
              },
            {
                state: 'paymenttemplates.list',
                config: {
                    url: '/list',
                    templateUrl: 'app/paymenttemplates/list.html?v=' + opsIncludeVersion,
                    controller: 'PaymentTemplateListController',
                    controllerAs: 'vm',
                    title: 'Payment Templates',
                    resolve: {
                        authenticationRequired: ['userService', function (userService) {
                            if (userService.userType() == "0") {
                                throw { name: "NotAdmin" };
                            }
                        }]
                    }
                }
            },
            {
                state: 'paymenttemplates.details',
             config: {
                 url: '/detail/:id',
                 templateUrl: 'app/paymenttemplates/details.html?v=' + opsIncludeVersion,
                 controller: 'PaymentTemplatesDetailsController',
                 controllerAs: 'vm',
                 title: 'Payment Gateway',
                 settings: {},
                 resolve: {
                     authenticationRequired: ['userService', function (userService) {
                         if (userService.userType() == "0") {
                             throw { name: "NotAdmin" };
                         }
                     }]
                 }
             }
            },
              {
                  state: 'paymenttemplates.pay',
                  config: {
                      url: '/pay/:id',
                      templateUrl: 'app/paymenttemplates/pay.html?v=' + opsIncludeVersion,
                      controller: 'PaymentTemplatePayController',
                      controllerAs: 'vm',
                      title: 'Make Payment'
                  }
            },
              {
                  state: 'paymenttemplates.receipt',
                  config: {
                      url: '/receipt/:id',
                      templateUrl: 'app/paymenttemplates/receipt.html?v=' + opsIncludeVersion,
                      controller: 'PaymentTemplateReceiptController',
                      controllerAs: 'vm',
                      title: 'Payment Receipt'
                  }
            },
            {
                state: 'paymenttemplates.error',
                config: {
                    url: '/error/:errorCode',
                    templateUrl: 'app/paymenttemplates/error.html?v=' + opsIncludeVersion,
                    title: 'Payment Error',
                    controller: 'PaymentTemplateErrorController',
                    controllerAs: 'vm'
                }
            }
          
        ];
    }
})();
